import React from "react";

class RadioConsensi extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const validField = !(typeof this.props.error != "undefined" && this.props.error != "");
    const validClass = !validField ? " notValid" : " valid";

    return (
      <React.Fragment>
        <div className={"multiradioContainer" + validClass} >
          <div className="content-radio" onClick={this.props.handler}>
            <div className={"check"}>
              <input type="radio" name={this.props.name} data-validation={this.props.validate ? this.props.validate : ""} value="1" />
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d={
                    this.props.value !== ""
                      ? "M17.2744 6.94444L10.764 13.6111L7.7258 10.5L5.55566 12.7222L10.764 18.0556L19.4446 9.16667L17.2744 6.94444Z"
                      : "M24.5 12.5C24.5 19.1274 19.1274 24.5 12.5 24.5C5.87258 24.5 0.5 19.1274 0.5 12.5C0.5 5.87258 5.87258 0.5 12.5 0.5C19.1274 0.5 24.5 5.87258 24.5 12.5Z"
                  }
                  fill="#333333"
                />
              </svg>
            </div>
            <label className="radioLabel">Acconsento</label>
          </div>
          <div className="content-radio" onClick={this.props.handler}>
            <div className={"check"}>
              <input type="radio" name={this.props.name} value="-1" />
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d={
                    this.props.value !== ""
                      ? "M17.2744 6.94444L10.764 13.6111L7.7258 10.5L5.55566 12.7222L10.764 18.0556L19.4446 9.16667L17.2744 6.94444Z"
                      : "M24.5 12.5C24.5 19.1274 19.1274 24.5 12.5 24.5C5.87258 24.5 0.5 19.1274 0.5 12.5C0.5 5.87258 5.87258 0.5 12.5 0.5C19.1274 0.5 24.5 5.87258 24.5 12.5Z"
                  }
                  fill="#333333"
                />
              </svg>
            </div>
            <label className="radioLabel">Non acconsento</label>
          </div>
        </div>
        {/* <div className={classFintoErrore}>
          il consenso è obbligatorio per il prosieguo del processo
        </div> */}
        <div className="error">
          {!validField ? this.props.error : ""}
        </div>
      </React.Fragment>
    );
  }
}

export default RadioConsensi


// WEBPACK FOOTER //
// ./src/components/dati_personali/components/radio_consensi.js